module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Profil bearbeiten")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "item"
  }, [_c('dp', {
    attrs: {
      "who": _vm.user
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("name")(_vm.user)))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png,image/bmp,image/gif",
      "id": "photo-upload"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit",
      "value": "Hochladen"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.uploadPhoto()
      }
    }
  })]), _vm._v(" "), _c('custom-form', {
    attrs: {
      "fields": [{
          name: 'username',
          title: 'Benutzername',
          type: 'text',
          disabled: true
        },
        'firstname', 'lastname', 'motto', 'racket',
        'school', 'year', 'yob', 'sex', 'city', 'handedness'
      ],
      "submitLabel": "Speichern",
      "url": "users/me/update"
    },
    on: {
      "submitted": _vm.updated
    },
    model: {
      value: (_vm.me),
      callback: function($$v) {
        _vm.me = $$v
      },
      expression: "me"
    }
  })], 1), _vm._v(" "), _c('section', [_c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": "change-password"
    }
  }, [_vm._v("\n            Passwort ändern\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49061cec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile-edit.vue
// module id = 225
// module chunks = 0